import { Icon } from "@mui/material";
import FlexBox from "./FlexBox";

interface Props {
  prerequisites: any;
}
export const PrerequisiteWarning = (props: Props) => {
  const { prerequisites } = props;
  return (
    <div
      className="visible-scrollbar"
      style={{
        background: "rgba(171, 171, 171, 0.1)",
        borderRadius: 5,
        padding: 20,
        minHeight: 400,
      }}
    >
      <FlexBox>
        <Icon
          title="Required for graduation"
          sx={{
            color: "yellow",
            paddingRight: "10px",
            // boxShadow: "0 4px 4px #0000007a",
          }}
        >
          warning
        </Icon>
        Please note: {prerequisites[0]?.focus_competency_code} has the following
        prerequisites:
      </FlexBox>
      <ul
        className="visible-scrollbar"
        style={{ maxHeight: 400, overflowY: "auto" }}
      >
        {prerequisites.map((v: any) => (
          <li>
            {v.prerequisite_competency_code} : {v.prerequisite_competency_title}
          </li>
        ))}
      </ul>
      You must have completed and recorded all prerequisite competencies before
      you will be allowed to record {prerequisites[0]?.focus_competency_code}.
      <br />
      <br />
      Continue adding {prerequisites[0]?.focus_competency_code}?
    </div>
  );
};
